import { BASE_IMG_URL } from 'const/ConstBase';
import './DownloadPage.scss';

const DownloadPage = () => {
    return (
        <div className='download-page'>
            <div
                className='page-header'
                style={{
                    backgroundImage: `url(${BASE_IMG_URL}lutador_download_header.webp)`,
                }}
            >
                <h1 className='download-title'>BAIXAR</h1>
                <p className='download-desc'>
                    Você está pronto para lutar?
                    <br /> Baixe o jogo, entre na batalha e descubra quem é o
                    melhor lutador.
                </p>

                <a className='header-link-button'>BAIXAR INICIALIZADOR</a>
            </div>

            <div className='download-page-content'>
                <h1 className='download-page-content__title'>
                    REQUISITOS DO SISTEMA
                </h1>

                <ul className='download-page-content__list'>
                    <li>
                        * É necessário ter no mínimo 2GB de espaço livre em
                        disco.
                    </li>
                    <li>
                        * Se tiver problemas durante a instalação, entre em
                        contato com o Suporte da.
                    </li>
                    <li>
                        * Para garantir uma solução rápida e precisa, anote as
                        especificações do seu sistema antes de entrar em contato
                        com o suporte.
                    </li>
                </ul>

                <table className='system-requirements'>
                    <thead>
                        <tr>
                            <th>CATEGORIA</th>
                            <th>RECOMENDADO</th>
                            <th>MÍNIMO</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>OS</td>
                            <td>Windows 7 (64-bit) ou superior</td>
                            <td>Windows XP</td>
                        </tr>
                        <tr>
                            <td>CPU</td>
                            <td>Intel Pentium Dual 3.0 Ghz ou superior</td>
                            <td>Intel Pentium 4.2 Ghz</td>
                        </tr>
                        <tr>
                            <td>DIRECTX</td>
                            <td>DIRECTX 9.0C</td>
                            <td>DIRECTX 9.0</td>
                        </tr>
                        <tr>
                            <td>VIDEO CARD</td>
                            <td>NVIDIA GeForce GTX 860 or later</td>
                            <td>NVIDIA GeForce 200</td>
                        </tr>
                        <tr>
                            <td>RAM</td>
                            <td>2 GB</td>
                            <td>1 GB</td>
                        </tr>
                    </tbody>
                </table>

                <a className='footer-link-button'>BAIXAR INICIALIZADOR</a>
            </div>
        </div>
    );
};

export default DownloadPage;
